import { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BusinessReplyForm = ({ review, onReplySubmitted }) => {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const [reply, setReply] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!reply.trim()) {
      toast.error('Por favor escribe una respuesta');
      return;
    }

    setSubmitting(true);
    try {
      await axios.patch(
        `${API}/reviews/${review.id}/reply`,
        { reply: reply.trim() },
        { headers: { 'X-Business-Id': user.id } }
      );
      
      toast.success('¡Respuesta publikada exitosamente!');
      setReply('');
      setShowForm(false);
      
      if (onReplySubmitted) {
        onReplySubmitted();
      }
    } catch (error) {
      console.error('Error submitting reply:', error);
      toast.error(error.response?.data?.detail || 'Error al publikar respuesta');
    } finally {
      setSubmitting(false);
    }
  };

  // Don't show if already replied
  if (review.businessReply) {
    return null;
  }

  return (
    <div className="mt-3">
      {!showForm ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setShowForm(true)}
          className="text-local-sage hover:text-local-sage/80"
          data-testid="show-reply-form-button"
        >
          <MessageSquare className="w-4 h-4 mr-2" />
          Responder
        </Button>
      ) : (
        <motion.form
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          onSubmit={handleSubmit}
          className="mt-4 p-4 bg-muted/30 rounded-xl"
          data-testid="reply-form"
        >
          <Textarea
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            placeholder="Responde a este kliente..."
            className="rounded-xl mb-3 min-h-[80px]"
            maxLength={500}
            required
            data-testid="reply-textarea"
          />
          <p className="text-xs text-muted-foreground mb-3">
            {reply.length}/500 karakteres
          </p>
          
          <div className="flex gap-2">
            <Button
              type="submit"
              disabled={submitting || !reply.trim()}
              className="bg-local-sage hover:bg-local-sage/90 rounded-full"
              size="sm"
              data-testid="submit-reply-button"
            >
              {submitting ? (
                'Publikando...'
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Publikar Respuesta
                </>
              )}
            </Button>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => {
                setShowForm(false);
                setReply('');
              }}
              disabled={submitting}
            >
              Kanselar
            </Button>
          </div>
        </motion.form>
      )}
    </div>
  );
};
